import { Link } from 'react-router-dom';

const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '银行级加密技术与多重安全防护体系，通过 ISO 27001 认证，全方位守护您的数据安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '高效敏捷',
    description: '智能化的 aqdlt 工作流引擎，大幅提升业务处理效率，让复杂任务变得简单快捷。',
  },
  {
    icon: 'ri-puzzle-line',
    title: '灵活扩展',
    description: '模块化的 aqdlt 平台架构，支持按需组合和灵活扩展，满足不同规模企业的个性化需求。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业服务',
    description: '7x24 小时全天候客户支持，专属顾问一对一服务，确保您的每个问题都能得到及时解决。',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: '数据驱动',
    description: '强大的数据分析引擎，实时洞察业务趋势，为决策提供精准的数据支撑。',
  },
  {
    icon: 'ri-global-line',
    title: '生态开放',
    description: '开放的 aqdlt 生态体系，丰富的 API 接口，轻松对接第三方系统，构建完整的业务闭环。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
              为什么选择 <strong className="text-primary-500">aqdlt</strong>
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              aqdlt 以卓越的技术实力和专业的服务能力，成为超过 10,000 家企业的共同选择
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="group p-6 rounded-lg bg-background-50 transition-all duration-300 hover:bg-background-50"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4 transition-colors duration-300 group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={`${feature.icon} text-xl`}></i>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}